import { MouseEvent } from "react";
import { Box } from "@mui/material";
import { IActionPlan } from "entities/RCA/ActionPlanEntity/ActionPlanEntityInterfaces";
import { translateDefaultEntity } from "utilities/localesUtilities";
import { DefaultTranslationFieldsInTable, RCA_STATUSES } from "constants/constants";
import { useTranslation } from "react-i18next";
import RCAStatusDropdown from "pages/Corporate/RCA/components/RCAStatusDropdown";
import { useActionPlanStatusCell } from "./useActionPlanStatusCell";

interface IActionPlanStatusCellProps {
    row: IActionPlan;
}

const ActionPlanStatusCell = ({ row }: IActionPlanStatusCellProps) => {
    const { i18n } = useTranslation();
    const { isEditing, statusId, handleStatusChange } = useActionPlanStatusCell(row);

    if (isEditing) {
        return (
            <Box
                onClick={(event: MouseEvent<HTMLDivElement>) => {
                    event.stopPropagation();
                }}
                sx={{ width: "100%", minWidth: 0 }}
            >
                <RCAStatusDropdown
                    hideLabel
                    fullWidth={false}
                    value={statusId}
                    forActionPlan
                    handleChange={handleStatusChange}
                    disabled={statusId === RCA_STATUSES.NEEDS_APPROVAL || statusId === RCA_STATUSES.REJECTED}
                    excludeStatuses={
                        statusId !== RCA_STATUSES.NEEDS_APPROVAL && statusId !== RCA_STATUSES.REJECTED
                            ? [RCA_STATUSES.NEEDS_APPROVAL, RCA_STATUSES.REJECTED]
                            : []
                    }
                />
            </Box>
        );
    }

    return (
        <div>{translateDefaultEntity(i18n.language, row.status, "name", DefaultTranslationFieldsInTable.STATUS)}</div>
    );
};

export default ActionPlanStatusCell;
